import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectFollowupReasonsInStore,
  selectFollowupReasonsPageLoading,
  selectFollowupReasonsShowInitWaitingMessage,
} from '../_selectors/followup-reason.selectors';

export class FollowupReasonsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectFollowupReasonsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectFollowupReasonsShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectFollowupReasonsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
